export default "__VITE_ASSET__e4bb99c2__"